import React, { useState } from 'react';
import { FormInputParams } from '../../model/form';
import { IconAddCircle, IconClose } from '../QuirkIcons';
import { IconButton } from '../IconButton';
import { FieldValuesType, FormValueType } from '../../hooks/useFormValues';
import styles from './FormInputList.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import commonStyles from './FormFields.module.css';
import classNames from 'classnames';

export type FieldListParams<T, K extends keyof T> = Omit<FormInputParams<T, K>, 'field' | 'type' | 'step'> & {
	field: FieldValuesType<string[] | undefined>;
	wrapItems?: boolean;
	placeholder?: string;
};

export function FormInputList<T, K extends keyof T>({
	setValues,
	id,
	field,
	nogap,
	label,
	onChange,
	wrapItems,
	placeholder
}: FieldListParams<T, K>) {
	const [state, setState] = useState<string>('');
	const onInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		setState(evt.target.value);
	};
	const onInputSubmit = () => {
		if (state !== '') {
			setValues({ [id]: (field?.value ?? []).concat([state]) } as FormValueType<T>);
			setState('');
		}
	};
	const onRemoveItem = (evt: React.MouseEvent<HTMLLIElement>, idx: number) => {
		const update = [...(field?.value ?? [])];
		update.splice(idx, 1);
		setValues({ [id]: update } as FormValueType<T>);
		onChange?.(evt);
	};
	const onKeyDown = (evt: React.KeyboardEvent<HTMLInputElement>) => {
		if (evt.key === 'Enter') {
			evt.preventDefault();
			onInputSubmit();
		}
	};
	return (
		<div className={styles.FormInputList} style={{ marginBottom: nogap ? '10px' : '30px' }}>
			<label className={classNames(commonStyles.label, styles.inputWrapper)}>
				{label}
				<input
					type="text"
					className={commonStyles.input}
					value={state}
					onChange={onInputChange}
					onKeyDown={onKeyDown}
					placeholder={placeholder}
				/>
			</label>
			<IconButton icon={<IconAddCircle />} onClick={onInputSubmit} disabled={state === ''} />
			<ul className={classNames(styles.inputList, wrapItems ? styles.wrapItems : null)}>
				{field.value?.map((item, i) => (
					<li key={`${i}-${item}`}>
						<IconButton icon={<IconClose />} onClick={evt => onRemoveItem(evt, i)} />
						{item}
					</li>
				))}
			</ul>
		</div>
	);
}
